<template>
  <div>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-row>
          <v-col cols="9" xs="12" sm="10" md="10" lg="10">
            <h1>ส่วนลด / คูปอง</h1>
          </v-col>
          <v-col cols="3" xs="12" sm="2" md="2" lg="2" class="text-right">
            <v-btn :color="formupdate.statusDiscount === 'False' ? 'red' : 'green'" rounded small outlined @click='open()'><v-icon>mdi-power</v-icon></v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" xs="12" sm="12" md="12" lg="12">
            <div style="display: flex; justify-content: center">
              <v-card
                @click="chooseImage"
                class="image-input"
                :style="{
                  'background-image': `url(${formupdate.pictureUrlPreview})`,
                  'background-size': 'contain',
                  'background-position': 'center center',
                  'background-repeat': 'no-repeat',
                }"
              >
                <div
                  style="position: absolute; top: -12px; right: -12px"
                  v-if="formupdate.pictureUrlPreview !== ''"
                >
                  <v-btn fab small color="#fff" @click.stop="deleteImg()"
                    ><v-icon>mdi-close</v-icon></v-btn
                  >
                </div>
                <span
                  v-if="formupdate.pictureUrlPreview === ''"
                  class="placeholder"
                  style="
                    justify-content: center;
                    align-items: center;
                    display: flex;
                    height: 100%;
                  "
                  >Choose an Image</span
                >
                <input
                  style="display: none"
                  class="file-input"
                  ref="fileInput"
                  type="file"
                  @input="onSelectFile"
                />
              </v-card>
            </div>

            <div
              style="
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <p>ขนาดรูปภาพที่แนะนำขนาด(กว้าง x ยาว) คือ 250 x 250 Pixel</p>
            </div>
            <div style="display: flex; justify-content: center">
              <div :style="{ width: resCol === '12' ? '100%' : '40%' }">
                <p>ชื่อ</p>
                <v-text-field
                  v-model="formupdate.name"
                  placeholder="ชื่อส่วนลด"
                  outlined
                  dense
                ></v-text-field>
                <p>ประเภท</p>
                <v-radio-group v-model="formupdate.radioType" row>
                  <v-radio label="เปอร์เซ็นต์" value="FIXED_PERCENT"></v-radio>
                  <v-radio label="ยอดเงิน" value="FIXED_AMOUNT"></v-radio>
                </v-radio-group>
                <p>จำนวนส่วนลด</p>
                <v-text-field
                  v-model="formupdate.number_discount"
                  placeholder="จำนวนส่วนลดที่ต้องการ"
                  outlined
                  dense
                  type="number"
                ></v-text-field>
                <p>วันหมดอายุ</p>
                <v-radio-group v-model="formupdate.radioExpri" row>
                  <v-radio label="ไม่มีวันหมดอายุ" value="notExpri"></v-radio>
                  <v-radio
                    label="หมดอายุหลังจากวันที่ได้รับ"
                    value="Expri"
                  ></v-radio>
                </v-radio-group>
                <v-text-field
                  v-if="formupdate.radioExpri === 'Expri'"
                  v-model="formupdate.expriDiscount"
                  type="number"
                  min="0"
                  placeholder="จำนวนวันหมดอายุ"
                  outlined
                  dense
                ></v-text-field>
              </div>
            </div>
            <div style="display: flex; justify-content: center">
              <div :style="{ width: resCol === '12' ? '100%' : '40%' }">
                <v-row>
                  <v-col class="text-right">
                    <v-btn color="error" @click="cancle()">ยกเลิก</v-btn>
                    <v-btn color="success" @click="update()">บันทึก</v-btn>
                  </v-col>
                </v-row>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-main>
  </div>
</template>

<script>
import axios from 'axios' // api
export default {
  computed: {
    resCol () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '12'
        case 'sm':
          return '12'
        case 'md':
          return '6'
        case 'lg':
          return '6'
        case 'xl':
          return '6'
      }
      console.log(
        'this.$vuetify.breakpoint.name',
        this.$vuetify.breakpoint.name
      )
    }
  },
  data () {
    return {
      filesAdd: null,
      formupdate: {
        pictureUrl: '',
        name: '',
        supply: 'Discount',
        number_discount: 0,
        statusDiscount: '',
        expriDiscount: '',
        pictureUrlPreview: '',
        radioExpri: 'notExpri',
        radioType: 'FIXED_PERCENT',
        shopId: '',
        CREATE_USER: '',
        expireTypeReward: 'Discount'
      },
      input: '',
      id: ''
    }
  },

  mounted () {
    this.getData()
  },

  methods: {
    chooseImage () {
      this.$refs.fileInput.click()
    },
    onSelectFile () {
      this.input = this.$refs.fileInput
      console.log(this.input.value)
      this.filesAdd = this.input.files
      if (this.filesAdd && this.filesAdd.length > 0) {
        this.formupdate.pictureUrlPreview = URL.createObjectURL(
          this.filesAdd[0]
        )
        this.formupdate.pictureUrl = URL.createObjectURL(this.filesAdd[0])
      } else {
        this.formupdate.pictureUrlPreview = ''
      }

      this.$forceUpdate()
    },
    deleteImg () {
      this.filesAdd = null
      this.formupdate.pictureUrlPreview = ''
      this.formupdate.pictureUrl = ''
      this.input.value = ''
    },
    cancle () {
      this.filesAdd = null
      this.formupdate.pictureUrlPreview = ''
      this.formupdate.picture = ''
      this.input.value = ''
      this.formupdate.pictureUrl = ''
      this.formupdate.name = ''
      this.formupdate.supply = 'discount'
      this.formupdate.radioType = 'FIXED_AMOUNT'
      this.formupdate.number_discount = 0
      this.formupdate.radioExpri = 'notExpri'
      this.formupdate.count_expri = ''
    },
    async update () {
      this.formupdate.shopId = this.$session.getAll().data.shopId
      this.formupdate.CREATE_USER = this.$session.getAll().data.userName
      await axios
        .get(
          this.DNS_IP +
            '/reward/getData?shopId=' +
            this.$session.getAll().data.shopId +
            '&expireTypeReward=Discount'
        )
        .then(async (res) => {
          console.log(res.data[0])
          if (res.data.status === false) {
            console.log('1')
            // insert
            if (this.filesAdd) {
              const _this = this
              let params = new FormData()
              params.append('file', this.filesAdd[0])

              await axios
                .post(this.DNS_IP + `/file/upload/reward`, params)
                .then(async function (response) {
                  _this.formupdate.pictureUrl = response.data
                })
            }
            this.formupdate.statusDiscount = 'False'
            await axios
              .post(this.DNS_IP + '/reward/add', this.formupdate)
              .then((res) => {
                this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
              })
            this.getData()
          } else {
            console.log('2')
            // update
            if (this.filesAdd) {
              const _this = this
              let params = new FormData()
              params.append('file', this.filesAdd[0])

              await axios
                .post(this.DNS_IP + `/file/upload/reward`, params)
                .then(async function (response) {
                  _this.formupdate.pictureUrl = response.data
                })
            }
            delete this.formupdate['pictureUrlPreview']
            await axios
              .post(this.DNS_IP + '/reward/edit/' + this.id, this.formupdate)
              .then(res => {
                this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
              })
            console.log('update')
            this.getData()
          }
        })
      console.log(this.formupdate)
    },
    open () {
      axios
        .get(this.DNS_IP + '/reward/getData?shopId=' + this.$session.getAll().data.shopId)
        .then(res => {
          console.log(res.data)
          if (res.data.status === false) {} else {
            this.formupdate.shopId = this.$session.getAll().data.shopId
            if (res.data[0].statusDiscount === 'False') {
            // update True
              const data = {
                'statusDiscount': 'True'
              }
              axios
                .post(this.DNS_IP + '/reward/edit/' + res.data[0].rewardId, data)
                .then(res => {
                  this.getData()
                  this.$swal('เรียบร้อย', 'เปิดใช้งาน', 'success')
                  //   this.getData()
                  console.log('update True', res)
                })
            } else {
            // update False
            //   this.formupdate.statusDiscount = 'False'
              const data = {
                'statusDiscount': 'False'
              }
              axios
                .post(this.DNS_IP + '/reward/edit/' + res.data[0].rewardId, data)
                .then(res => {
                  this.getData()
                  this.$swal('เรียบร้อย', 'ปิดใช้งาน', 'success')
                  //   this.getData()
                  console.log('update False', res)
                })
            }
          }
        })
    },
    getData () {
      console.log('dd')
      axios
        .get(this.DNS_IP + '/reward/getData?shopId=' + this.$session.getAll().data.shopId)
        .then(res => {
          console.log('res.datda', res.data)
          if (res.data.status !== false) {
            this.formupdate.pictureUrl = res.data[0].pictureUrl
            this.formupdate.name = res.data[0].name
            this.formupdate.number_discount = res.data[0].number_discount
            this.formupdate.expriDiscount = res.data[0].expriDiscount
            this.formupdate.pictureUrlPreview = res.data[0].pictureUrl
            this.formupdate.radioExpri = res.data[0].radioExpri
            this.formupdate.radioType = res.data[0].radioType
            this.id = res.data[0].rewardId
            this.formupdate.statusDiscount = res.data[0].statusDiscount
          }
        })
    }
  }
}
</script>

<style scoped>
.image-input {
  display: block;
  width: 300px;
  height: 300px;
  /* min-width: 300px;
  min-height: 300px; */
  cursor: pointer;
  background-size: cover;
  background-position: center center;
}
</style>



// WEBPACK FOOTER //
// src/components/Master/Discount.vue